<script>
import {Timestamp} from '@src/db';
import dayjs from '@common/dayjs';


export default {
  name: 'FcmDate',
  components: {},
  inject: {
    form: { default: null }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      validator: (value)=>{return true},
      default: ()=>{return null;},
    },
    min: {
      validator: (value)=>{return true},
      default: ()=>{return undefined;},
    },
    max: {
      validator: (value)=>{return true},
      default: ()=>{return undefined;},
    },
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    mask: {
      type: [String, Array],
      default: '##/##/####' // ##/##/#### ##:##
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY' // DD/MM/YYYY HH:mm
    },
    type: {
      type: String,
      default: 'firestore',    // firestore || date || string || dayjs || iso
    },
    modelFormat: {  // Só é relevante no type === string
      type: [String, null],
      default: null
    },
    pickTime: {
      type: Boolean,
    },
    btnDone: {
      type: String,
      default: '',
    },
    startOnYear: {
      type: Boolean,
    },
    startOnMonth: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default: ()=>[],
    },
    readOnly: {
      type: Boolean,
    },
    pickMonth: {
      type: Boolean,
    },
    hideSelected: {
      type: Boolean
    },
    appendIcon: {
      type: String,
      default: undefined,
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
    setNowOnClickIfEmpty: {
      type: Boolean
    },
  },
  data(vm) {
    return {
      showModal: false,
      items: [],
      internalLazyValue: (()=>{
        return vm.toDayjs(this.value);
      })(),
      menu: false,
      internalErrorMessages: [],
      hasInput: false,
      activePicker: 'DATE',
    }
  },
  computed: {
    shouldValidate() {
      if(this.rules && this.rules.length>0) {
        return true;
      }
      return false;
    },
    // The inner VTextField's own v-model is internalValueShow (the formatted display string,
    // e.g. "14/07/2008"), not the semantic value the rules were written for (form.birthDateISO,
    // an ISO string). Vuetify calls each rule with whatever it validates (the display string),
    // so passing `rules` straight through would run e.g. minAgeRule against the wrong format.
    // These wrappers ignore that argument and validate the real model value instead — this is
    // also what lets VForm's own validate()/resetValidation() actually see this field, which a
    // bare :error-messages binding does not.
    wrappedRules() {
      return this.rules.map(rule => {
        if (typeof rule !== 'function') {
          return rule;
        }
        return () => rule(this.toModel(this.internalLazyValue));
      });
    },
    hasError () {
      return this.internalErrorMessages.length>0;
    },
    internalValuePicker: {
      get() {
        return this.internalLazyValue?this.internalLazyValue.format('YYYY-MM-DD'):null;
      },
      set(val) {
        if(this.pickTime) {
          val = dayjs(val, 'YYYY-MM-DD')
            .hour(this.internalLazyValue?this.internalLazyValue.hour():0)
            .minute(this.internalLazyValue?this.internalLazyValue.minute():0);
        }
        else {
          val = dayjs(val, 'YYYY-MM-DD');
        }
        this.updateInternalLazyValue(val);
      }
    },
    internalValuePickerTime: {
      get() {
        return this.internalLazyValue?this.internalLazyValue.format('HH:mm'):'';
      },
      set(val) {
        let hourMinute = dayjs(val, 'HH:mm');
        let tmp = dayjs(this.internalLazyValue)
          .hour(hourMinute.hour()||0)
          .minute(hourMinute.minute()||0);
        this.updateInternalLazyValue(tmp);
      }
    },
    internalValueShow: {
      get() {
        return this.internalLazyValue?this.internalLazyValue.format(this.format):'';
      },
      set(val) {

      }
    }
  },
  watch: {
    value(val) {
      val = this.toDayjs(val);
      this.updateInternalLazyValue(val, true)
    },
    menu(val) {
      if(val && !this.internalLazyValue && this.setNowOnClickIfEmpty) {
        this.updateInternalLazyValue(dayjs());
      }
      if(val && this.$refs.timePicker) {
        this.$refs.timePicker.selectingHour = true
      }
      if(val && this.startOnYear) {
        setTimeout(()=>{
          this.activePicker = 'YEAR';
          // if(this.$refs.datePicker) {
          //   this.$refs.datePicker.internalActivePicker = 'YEAR';
          // }
        },50);
      }
      else if(val && (this.startOnMonth || this.pickMonth)) {
        setTimeout(()=>{
          this.activePicker = 'MONTH';
          // if(this.$refs.datePicker) {
          //   this.$refs.datePicker.internalActivePicker = 'MONTH';
          // }
        },50);
      }
      else {
        setTimeout(()=>{
          this.activePicker = 'DATE';
          // if(this.$refs.datePicker) {
          //   this.$refs.datePicker.internalActivePicker = 'DATE';
          // }
        },50);
      }
    }
  },
  created () {
    this.form && this.form.register(this)
  },
  mounted: async function() {
  },
  beforeDestroy: function() {
    this.form && this.form.unregister(this);
  },
  methods: {
    updateInternalLazyValue(value, noEmit=false) {
      if(!value || typeof value.isValid!=='function' || !value.isValid()) {
        value = null;
      }
      if(value===null && this.internalLazyValue===null) {
        return;
      }
      if (value===null || this.internalLazyValue===null || !this.internalLazyValue.isSame(value)) {
        this.resetValidation();
        this.internalLazyValue = value;
        if(!noEmit) {
          this.$emit('input', this.toModel(this.internalLazyValue));
        }
      }
    },
    toDayjs(input) {
      if(!input) {
        return null;
      }
      let d = null;
      if(typeof input.toDate ==='function') {
        d = dayjs(input.toDate());
      }
      else if(typeof input==='string') {
        d = this.modelFormat ? dayjs(input, this.modelFormat) : dayjs(input);
      }
      else if(input.seconds>0 || input.nanoseconds>0) {
        d = dayjs((input.seconds*1000)+(input.nanoseconds/10e6));
      }
      else {
        d = dayjs(input);
      }
      if(d?.isValid?.()) {
        return d;
      }
      return null;
    },
    toModel(val) {
      if(!(val?.isValid?.())) {
        return null;
      }
      switch (this.type) {
        case 'firestore':
          return new Timestamp.fromDate(val.toDate());
        case 'string':
          return val.format(this.modelFormat || 'YYYY-MM-DD');
        case 'iso':
          if(this.pickTime) {
            return val.format('YYYY-MM-DD HH:mm');
          }
          else {
            return val.format('YYYY-MM-DD');
          }
        case 'date':
          return val.toDate();
        case 'dayjs':
          return dayjs(val);
        default:
          console.error('FcmDate: type unknown', this.type);
      }
    },
    // Typed text in the display format, parsed strictly so an impossible date (31/02) is invalid; without the time, or with
    // an incomplete one, the date alone is used
    parseInput(text) {
      const parsed = dayjs(text, this.format, true);
      if(parsed.isValid()) {
        return parsed;
      }
      const dateFormat = this.format.split(' ')[0];
      return dayjs(text.slice(0, dateFormat.length), dateFormat, true);
    },
    saveAction() {
      this.$emit('dialogConclude', null);
      this.showModal = false;
    },
    onBlur(event) {
      if(event.target) {
        if(event.target.value) {
          const val = this.parseInput(event.target.value);
          this.updateInternalLazyValue(val);
        }
        else {
          // Field was cleared by hand — internalValueShow's own setter is a no-op, so without
          // this the stale internalLazyValue (e.g. the pre-filled default birth date) would
          // never actually be nulled, silently passing "required" and getting saved anyway.
          this.updateInternalLazyValue(null);
        }
      }
    },
    onPickDate() {
      if(this.pickTime) {

      }
      else {
        this.menu = false;
      }
    },
    onPickTime() {
      this.menu = false;
    },
    done() {
      this.menu = false;
    },

    removeFocus() {
      if(this.$refs.textField && typeof this.$refs.textField.blur==='function') {
        setTimeout(()=>{this.$refs.textField.blur();}, 10);
      }
    },
    reset () {
      this.hasInput = false;
      this.internalErrorMessages = [];
      this.updateInternalLazyValue(null);
      this.removeFocus();
    },
    resetValidation () {
      this.hasInput = false;
      this.internalErrorMessages = [];
    },
    validate (force=false) {
      this.internalErrorMessages = [];
      for (const rule of this.rules) {
        const result = typeof rule === 'function' ? rule(this.internalLazyValue) : rule;
        if (typeof result === 'string') {
          this.internalErrorMessages.push(result);
        }
      }
      if (force) {
        this.hasInput = true;
      }
      return this.internalErrorMessages.length === 0;
    },
    keyEnter(event) {
      if(!event.target.value) {
        this.updateInternalLazyValue(null);
        return;
      }
      const val = this.parseInput(event.target.value);
      if(val.isValid()) {
        this.updateInternalLazyValue(val);
        this.menu = false;
      }
    },
    clickMonth(value) {
      if (this.pickMonth) {
        this.updateInternalLazyValue(dayjs(value + '-01 12:00'));
        this.menu = false;
      }
    }
  },
}
</script>


<template>
    <VMenu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
      <template #activator="{ on, attrs }">
        <VTextField
            v-if="!hideSelected"
            ref="textField"
            v-model="internalValueShow"
            v-mask="mask"
            :label="label"
            v-bind="{...attrs, ...$attrs}"
            :rules="wrappedRules"
            :error-messages="internalErrorMessages"
            :readonly="readOnly"
            :class="className"
            inputmode="numeric"
            :append-icon="appendIcon"
            autocomplete="no"
            @blur="onBlur"
            @keyup.enter="keyEnter"
            v-on="(!readOnly)?on:''"
        >
          <template v-if="!iconRight" #prepend-inner>
            <VIcon tabindex="-1" @click="(!readOnly)?on.click($event):''">mdi-calendar</VIcon>
          </template>
          <template v-if="iconRight" #append>
            <VIcon tabindex="-1" @click="(!readOnly)?on.click($event):''">mdi-calendar</VIcon>
          </template>
        </VTextField>
      </template>
      <div class="box">
        <VDatePicker
            ref="datePicker"
            v-model="internalValuePicker"
            color="primary"
            no-title
            :active-picker="activePicker"
            :min="min"
            :max="max"
            @input="onPickDate"
            @click:month="clickMonth"
        ></VDatePicker>
        <VTimePicker
            v-if="pickTime"
            ref="timePicker"
            v-model="internalValuePickerTime"
            color="primary"
            format="24hr"
            no-title
            @click:minute="onPickTime"
        ></VTimePicker>
        <VBtn v-if="btnDone" @click="done">{{btnDone}}</VBtn>
      </div>
    </VMenu>
</template>


<style lang="scss" scoped>
 // @import '@design';
  .box {
    display: flex;
    flex-direction: column;
    background-color: var(--v-modalHeaderBg-base);
  }
</style>





















